// src/hooks/useAccess.ts
import { useTenant } from '../providers/TenantProvider'
import { canAccess, type FeatureKey } from '../config/tenantAccess'

export function useAccess() {
  const { orgSlug } = useTenant()
  return {
    orgSlug,
    can: (feature: FeatureKey) => canAccess(feature, orgSlug)
  }
}
